<div class="second-page">
    <div class="top-menu">
        <div class="header-logo"><img class="logo-img" src="/assets/Slay.svg" style="margin-left:30px" /></div>
        <div class="header-menu">
            <div class="make-appointment-btn"><span style="margin-right:10px">Make a Appointment</span> <img
                    src="/assets/next-arrow.svg" class="arrow-img" />
            </div>
            <!-- <button class="menu-btn" mat-button [matMenuTriggerFor]="menu"><img class="hamburger-menu"
                    src="/assets/menu.png" /></button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item [routerLink]="'/aligner'" xPosition="after" yPosition="below">Aligner</button>
                <button mat-menu-item xPosition="after" yPosition="below">About</button>
            </mat-menu> -->
        </div>


    </div>
    <div class="first-section">
        <div class="content-section">
            <div class="header1">
                Slay Aligners - <br />
                <span class="header2">Where Innovation Meets
                    Confidence</span>
            </div>
            <div class="content1">At Slay, we believe that straightening your
                teeth should be effortless, stylish, and pain-free.
                That’s why we created Shape Memory Aligners
                (SMA)—the world’s first 3D-printed aligners with
                shape memory technology. Unlike traditional
                clear aligners, Slay Aligners adapt to you,
                not the other way around.</div>

        </div>
        <div class="image-section">
            <img src="/assets/first-section-bg.png" class="left-bg">
        </div>
    </div>
    <div class="second-section">
        <div class="img-container1">
            <img src="/assets/first-img.png" class="first-img" />
            <img src="/assets/second-img.png" class="second-img" />
            <img src="/assets/third-img.png" class="third-img" />
        </div>
        <div class="img-container2">
            <img src="/assets/fourth-img.png" class="fourth-img" />
        </div>
        <div class="img-container3">
            <img src="/assets/fifth-img.png" class="fifth-img" />
            <img src="/assets/sixth-img.png" class="sixth-img" />
        </div>
    </div>
    <div class="third-section">
        <div class="third-header center-header">
            How do Slay orthodontic clear aliger treatments work ?
        </div>
        <div class="third-container">
            <div class="left-img">
                <img src="/assets/third-bg.png" class="left-bg">
            </div>
            <div class="right-content">
                <div class="step-number black-step mb2">1</div>
                <div class="third-header mb2 " style="text-align:left;">Complimentary
                    Consultation</div>
                <div class="third-content">Get a Complimentary Consultation with our expert dentists! Assess your oral
                    health with no
                    cost. Book your appointment today and take the first step toward a healthier smile</div>
                <div class="make-appointment-btn right-btn"><span style="margin-right:10px;color:white">Make a
                        Appointment</span> <img src="/assets/back-white.png" class="arrow-img" />
                </div>
            </div>
        </div>
    </div>
    <div class="fourth-section">
        <img src="/assets/fourth-bg.png" class="side-bg-imgs">
        <div class="fourth-content-card">
            <div class="step-number black-step mb2">2</div>
            <div class="third-header mb2" style="text-align:left;">Customized
                Treatment Plan</div>
            <div class="third-content" style="color: #595959;
">Receive a Customized Treatment Plan tailored to your unique dental needs. Our experts will assess your oral health
                and create a personalized plan just for you. Achieve optimal results with treatments designed for
                your specific goals.</div>
        </div>
    </div>
    <div class="third-section">
        <div class="third-container">
            <div class="left-img">
                <img src="/assets/fifth-bg.png" class="left-bg">
            </div>
            <div class="right-content">
                <div class="step-number black-step mb2">3</div>
                <div class="third-header mb2" style="text-align:left;">The Beginning of
                    treatment</div>
                <div class="third-content">Embark on your dental treatment journey with confidence. Our experienced team
                    will guide you through each step, ensuring a comfortable experience. We begin by assessing your
                    unique needs and crafting a tailored treatment plan. From the first visit to the final results,
                    we’re with you every step of the way. Start your treatment today for a healthier, more radiant
                    smile!</div>
            </div>
        </div>
    </div>
    <div class="fourth-section">
        <img src="/assets/sixth-bg.png" class="side-bg-imgs">
        <div class="fourth-content-card">

            <div class="step-number black-step mb2">4</div>
            <div class="third-header mb2" style="text-align:left;">Follow ups &
                Check ins</div>
            <div class="third-content" style="color: #595959;
">Stay on track with our Follow-ups & Check-ins to ensure your treatment is progressing smoothly. Our team will
                schedule regular appointments to monitor your progress and address any concerns. Consistent check-ins
                help maintain your oral health and ensure long-lasting results. We’re here to support you at every
                stage.</div>
        </div>
    </div>
    <div class="third-section">
        <div class="third-container">
            <div class="left-img">
                <img src="/assets/seventh-bg.png" class="left-bg">
            </div>
            <div class="right-content">
                <div class="step-number black-step mb2">5</div>
                <div class="third-header mb2" style="text-align:left;">Show your teeth!</div>
                <div class="third-content">Show your teeth with confidence! A bright, healthy smile can make all the
                    difference. Our expert team is here to help you achieve the smile you've always dreamed of. Whether
                    it's a routine cleaning, whitening, or a complete transformation, we’ve got you covered. Feel proud
                    of your smile and show it off every day! Book your appointment now and let us bring out the best in
                    your teeth!</div>
            </div>
        </div>
    </div>
    <div class="footer-section">
        <div class="home-menu">
            <div class="menu-header">Company</div>
            <div class="menu-items">Why Impress?</div>
            <div class="menu-items">Press</div>
            <div class="menu-items">Jobs</div>
            <div class="menu-items">Blog</div>
            <div class="menu-items">Student Beans</div>
        </div>
        <div class="home-menu">
            <div class="menu-header">Product</div>
            <div class="menu-items">Adult Aligners</div>
            <div class="menu-items">Teens Aligners</div>
            <div class="menu-items">Retainers</div>
            <div class="menu-items">Professional Whitening</div>
            <div class="menu-items">Veeners</div>
            <div class="menu-items">Pricing</div>
            <div class="menu-items">Results</div>
        </div>
        <div class="home-menu">
            <div class="menu-header">Legal Notice</div>
            <div class="menu-items">Privacy Policy</div>
            <div class="menu-items">Cookies Policy</div>
            <div class="menu-items">Legal Notice</div>
            <div class="menu-items">Complaints Policy</div>
        </div>
        <div class="home-menu">
            <div class="menu-header">Support</div>
            <div class="menu-items">FAQs</div>
            <div class="menu-items">+44 40 2898 1270</div>
            <div class="menu-items">Whatsapp</div>
            <div class="menu-items">Email</div>
            <div class="menu-items" style="display:flex;">
                <img src="/assets/linkedin.png" class="menu-icon">
                <img src="/assets/facebook.png" class="menu-icon">
                <img src="/assets/instagram.png" class="menu-icon">
            </div>
            <div class="menu-items">Mon - Fri, 9:00 - 20:00</div>
            <div class="menu-items">Sat, 9:00 - 18:00</div>
        </div>
    </div>

</div>